// extracted by mini-css-extract-plugin
export default {"lang-bar":"LanguageSelect_lang-bar__l881D","lang-btn":"LanguageSelect_lang-btn__dOVjN","active":"LanguageSelect_active__DTHwI"};